import { styled } from "@mui/material";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import HeaderImage from "../Images/Header Image.png";
import "../style.css";
import { useNavigate } from "react-router";

const H1 = styled(Typography)((theme) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "56px;",
  lineHeight: "110%",
  letterSpacing: "-0.01em;",
  color: "#000000;",
}));

const H2 = styled(Typography)((theme) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "40px",
  lineHeight: "125%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const H3 = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "24px",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const H4 = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "600",
  fontSize: "20px",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const P = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "150%",
  letterSpacing: "0.01em",
  color: "#1A1824",
}));

const Btn = styled(Button)(({ theme }) => ({
  padding: "5px 20px;",
  border: "1px solid #559A95;",
  backgroundColor: "#2B817B",
  fontSize: "20px;",
  fontWeight: "600",
  borderRadius: "8px;",
  color: "white",
}));

function Header() {
  let navigate = useNavigate();

  return (
    <>
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: {
            lg: "space-around",
            md: "space-between",
            sm: "space-between",
            xs: "space-between",
          },
          flexDirection: {
            lg: "row",
            md: "row",
            sm: "column-reverse",
            xs: "column-reverse",
          },
        //   border: "1px solid red",
        }}
        maxWidth="xl"
      >
        <Box className="bg_img_container" maxWidth="md">
          <H1
            sx={{
              fontSize: { lg: "56px", md: "40px", sm: "35px", xs: "35px" },
            }}
          >
            Expand market, increase <br /> turnover, grow your business
          </H1>
          <P
            className="headerPara"
            sx={{
              mt: 1,
              fotnSize: {
                lg: "20px",
                md: "20px",
                sm: "12px",
                xs: "12px",
                width: "524px",
                // border: "1px solid red",
              },
            }}
          >
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been
          </P>
          {/* <Btn sx={{mt:2,fontSize:{lg:'20px',md:'20px',sm:'16px',xs:'16px',width:{lg:'250px',md:'250px',sm:'180px',xs:'180px'},height:{lg:'68px',md:'50px',sm:'40px',xs:'40px'}}}}>Become A Caterer</Btn> */}
          <Button
            variant="contained"
            size="large"
            sx={{
              textTransform: "capitalize",
              my: "15px",
            }}
            onClick={() => navigate("/merchantregistration")}
          >
            Become A Caterer
          </Button>
        </Box>
        <Box
          className="imgContainer"
          sx={
            {
              // border: "1px solid red",
              // width: { lg: "432px", md: "445px", sm: "500px", xs: "500px" },
            }
          }
        >
          <img
            className="headerImage"
            style={{
              width: "432px",
              //   border: "1px solid green",
              height: "480px",
              margin: "5px auto",
            }}
            src={HeaderImage}
          />
        </Box>
      </Container>
    </>
  );
}

export default Header;
